export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/9efedd6f8d84b8cf11b1862201b47d04.svg";